// Thin wrapper around a full-page navigation so tests can mock it; jsdom's window.location can't be replaced
export const redirectTo = (url: string) => {
  window.location.href = url
}
